// src/hooks/useAnalytics.js — Umami analytics
// Tracker les events Takkyu Oni sans cookies, RGPD-friendly
//
// Setup :
//   1. Ajouter dans public/index.html :
//      <script async defer data-website-id="TON_WEBSITE_ID"
//              src="https://ton-umami.com/script.js"></script>
//   2. Mettre REACT_APP_UMAMI_WEBSITE_ID dans .env (optionnel, pour vérif)

// Umami expose window.umami automatiquement via le script tag
const track = (eventName, eventData) => {
  try {
    if (typeof window !== "undefined" && window.umami) {
      window.umami.track(eventName, eventData);
    }
  } catch(e) {
    // Umami non chargé (bloqué par adblock etc.) — silencieux
  }
};

// ── Events standardisés Takkyu Oni ────────────────────────────────────
export const analytics = {
  // Onboarding
  quizStarted:      ()                => track("quiz_started"),
  quizCompleted:    (oniName)         => track("quiz_completed",    { oni: oniName }),
  demonSaved:       (oniName)         => track("demon_saved",       { oni: oniName }),
  accountCreated:   ()                => track("account_created"),

  // Journal
  journalOpen:      ()                => track("journal_open"),
  chronicleGenerated: (verdict)       => track("chronicle_generated", { verdict }),
  chronicleSaved:   (verdict, xp)     => track("chronicle_saved",   { verdict, xp }),

  // Duel
  duelStarted:      (mode)            => track("duel_started",      { mode }),        // mode: "user" | "custom"
  duelCompleted:    (won, oniName)     => track("duel_completed",    { won, oni: oniName }),

  // Team
  teamBattleCreated:(size)            => track("team_battle_created",{ size }),
  teamBattleJoined: ()                => track("team_battle_joined"),
  duelPlayed:       ()                => track("duel_played"),

  // Shop
  shopView:         (productName)     => track("shop_view",         { product: productName }),
  checkoutStarted:  (productName, price) => track("checkout_started", { product: productName, price }),
  orderCompleted:   (productName)     => track("order_completed",   { product: productName }),

  // Coach
  coachAnalysis:    (preset)          => track("coach_analysis",    { preset }),

  // Reform
  reformStarted:    ()                => track("reform_started"),
  reformCompleted:  (oldOni, newOni)  => track("reform_completed",  { from: oldOni, to: newOni }),

  // FFTT
  ffttSearch:       ()                => track("fftt_search"),
  preyAdded:        ()                => track("prey_added"),

  // Navigation
  pageView:         (page)            => track("page_view",         { page }),

  // Sharing
  profileShared:    ()                => track("profile_shared"),
  chronicleShared:  ()                => track("chronicle_shared"),
  duelShared:       ()                => track("duel_shared"),

  // Custom event brut
  event:            (name, data)      => track(name, data),
};

// ── Hook React pour page views automatiques ───────────────────────────
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    analytics.pageView(location.pathname);
  }, [location.pathname]);
}

export default analytics;
